var _defs, _circle, _circle2, _path, _path2, _path3, _rect, _rect2, _path4, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 220",
    width: 200,
    height: 220,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffe27a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#f0a020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d88810"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5ad2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a7dff"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 78,
    fill: "url(#b)",
    opacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 68,
    fill: "none",
    stroke: "url(#b)",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 70h60v8c0 22-12 40-30 46-18-6-30-24-30-46v-8z",
    fill: "url(#g)",
    stroke: "#c47810",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 78c-14 2-24 14-24 28 0 10 6 18 14 22",
    fill: "none",
    stroke: "url(#g)",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130 78c14 2 24 14 24 28 0 10-6 18-14 22",
    fill: "none",
    stroke: "url(#g)",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 122,
    width: 24,
    height: 18,
    rx: 3,
    fill: "url(#g)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 140,
    width: 56,
    height: 12,
    rx: 4,
    fill: "url(#g)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 180h80l-8 20H68z",
    fill: "#1a2f6e",
    stroke: "#5ad2ff",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 195,
    textAnchor: "middle",
    fontFamily: "Arial,sans-serif",
    fontSize: 11,
    fontWeight: 700,
    fill: "#fff"
  }, "CHAMPION")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.9dfc9178daa4bedb49d227b8afbbce31.svg";
export { ForwardRef as ReactComponent };